// Session expiration timeout for logged users
export const SESSION_EXPIRATION = 60 * 60 * 24 * 180; //ca. half year